import React, { useEffect, useState } from "react";
import {
    PDFViewer,
    Document,
    Page,
    View,
    Text,
    StyleSheet,
    Font,
    Image,
} from "@react-pdf/renderer";
import { Alert, Button, Modal } from "antd";
import DSILogo from "../../assets/DST-logo.jpg";
import SAASTALogo from "../../assets/saasta-logo.png";
import { util } from "../../utils/functions/custom";

import { GenericChart } from "./GenericChart";
import { reportTypeEnum } from "./AppEnums";
import { GenericGeoMap } from "./GenericGeoMap";
import { DownloadDataAsExcel } from "../custom";

// Define custom font
Font.register({
    family: "Roboto",
    src: "https://fonts.gstatic.com/s/roboto/v27/KFOmCnqEu92Fr1Mu4mxP.ttf",
});

export const ReportTemplatePartner = ({ show, onCancel, reportOutProps, isGeo, isFunnel }) => {
    const [imageSrc, setImageSrc] = useState(null);
    const [legendSrc, setLegendSrc] = useState(null);
    const [pdfView, setPdfView] = useState(false);
    const [TableList, setTableList] = useState(["Table 1", "Table 2", "Table 3"]);

    // Define styles
    const styles = StyleSheet.create({
        columns: {
            backgroundColor: "#eee",
            color: "#000",
            padding: "10px 0 10px 4px",
            textAlign: "left",
            width: 200,
            fontWeight: "ultrabold",
            fontSize: "14px",
        },
        columns__short: {
            backgroundColor: "#eee",
            color: "#000",
            padding: "0.5cm",
            textAlign: "left",
            width: 100,
        },
        columnsvals: {
            color: "#1B1919",
            padding: "10px 0 10px 4px",
            textAlign: "left",
            width: 200,
            borderBottomColor: "#efefef",
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
        },
        columnsvals__summary: {
            padding: "10px 0 10px 4px",
            textAlign: "left",
            width: 200,
        },
        columnsvals__short: {
            color: "#000",
            padding: "0.5cm",
            textAlign: "left",
            width: 100,
        },
        footer: {
            position: "absolute",
            bottom: 30,
            left: 0,
            right: 0,
            textAlign: "center",
            fontSize: 12,
            color: "grey",
        },
        header: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: 30,
            width: "100%",
        },
        images: {
            width: "100%",
            maxWidth: "1200px", // avoiding the image from autscaling issues
            imageRendering: "crisp-edges"
        },
        legend: {
            width: "100px",
            height: "100px",
            position: "absolute",
            padding: "10px 10px",
            flexDirection: "column",
            alignItems: "right",
            bottom: "0px",
            right: "34px",
            boxShadow: "0 0 5px 0 rgba(184, 140, 140, 0.3)",
            background: "rgba(0,0,0,0.8)",
        },
        logo: {
            width: 120,
            height: 50,
        },
        meta_field_value: {
            color: "#000",
            padding: "6px",
            textAlign: "left",
            fontWeight: "ultrabold",
            width: 250,
            fontFamily: "Roboto",
        },
        page: {
            flexDirection: "column",
            alignItems: "center",
            fontFamily: "Roboto",
            padding: "1cm",
        },
        preview__report: {
            display: "flex",
            justifyContent: "space-between",
        },
        reportDesc: {
            textAlign: "center",
            fontSize: 20,
            marginBottom: 30,
            padding: "10px 0 10px 4px",
            fontWeight: "bold",
        },

        section: {
            flexDirection: "row",
            fontSize: 12,
        },
        subheader: {
            fontSize: 18,
            marginBottom: "0.5cm",
        },
        summary: {
            flexDirection: "column",
            fontSize: pdfView ? 7 : 10,
            width: "100%",
            marginTop: "20px",
            paddingBottom: "20px",
        },
        summary__content: {},
        table: {
            marginBottom: 30,
            flexDirection: "column",
            width: "100%",
        },
        table_layout: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
            borderTopColor: "#000",
            borderTopStyle: "solid",
            borderTopWidth: "1px",
            borderBottomColor: "#000",
            borderBottomStyle: "solid",
            borderBottomWidth: "1px",
            fontSize: 12,
        },
        table_row: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
            width: "100%",
            fontSize: 12,
            borderBottomColor: "#efefef",
            borderBottomStyle: "solid",
            borderBottomWidth: "1px",
        },
        table_col_w48: {
            padding: "4px 8px",
            width: "48%",
        },
        table_start_col_w48: {
            padding: "4px 8px",
            maxWidth: "70px",
            backgroundColor: "#efefef",
            paddingRight: 10,
        },
        table_col_w60: {
            padding: "4px 2px",
            width: "41%",
        },
        table_col_val_w60: {
            padding: "2px 2px",
            width: "41%",
        },
        table_col_w40: {
            padding: "4px 8px",
            width: "40%",
        },
        table_col_header: {
            textAlign: "left",
            color: "#1f1f1f",
            fontWeight: "bold",
            fontSize: 13,
        },
        table_title: {
            fontWeight: "bold",
            textAlign: "left",
            width: "100%",
            fontSize: 12,
        },
    });

    const [chartSize, setChartSize] = useState("70%");


    const handleImageSrc = (imageSrc) => {
        setImageSrc(imageSrc);
        //Wait for 1 seconds for the image to be properly printed
        const interval = setTimeout(() => setImageSrc(imageSrc), 1000);
        return () => clearInterval(interval);
    };

    const handleLegendSrc = (legend) => {
        //Wait for 1 seconds for the image to be properly printed
        const interval = setTimeout(() => setLegendSrc(legend), 1000);
        return () => clearInterval(interval);
    };

    useEffect(() => {
        // setChartSize("45%");
    }, [])

    const onPrint = () => {
        setPdfView(true);
    };

    const onModalCancel = () => {
        setPdfView(false);
        onCancel();
        setImageSrc(null)
    };

    const onCloseInfo = () => { };

    const onDownload = () => {

        const { data, title, type, year } = reportOutProps;

        let csvContent;
        if (reportOutProps?.type === reportTypeEnum.GROUPCOL || type === reportTypeEnum.HEATMAP || type === reportTypeEnum.STACKED_AREA) {
            const groupedData = util.groupPartnerData(data, year);

            csvContent = "data:text/csv;charset=utf-8," + util.convertArrayDataToCSV(groupedData);
            DownloadDataAsExcel(groupedData, title);
            
            return;
        } else {
            csvContent = "data:text/csv;charset=utf-8," + util.convertArrayDataToCSV(data);
            DownloadDataAsExcel(data, title);
            
        }
        //Download data as CSV
        const encodedURI = encodeURI(csvContent);

        //Allow the selected to be downloadable through an anchor popup
        const link = document.createElement("a");
        link.setAttribute("href", encodedURI);
        link.setAttribute("download", title);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const renderTableHeaders = (isPdfView) => {

        if (
            // reportOutProps?.type === reportTypeEnum.STUCKED_COLUMN ||
            reportOutProps?.type === reportTypeEnum.GROUPCOL ||
            reportOutProps?.type === reportTypeEnum.GROUPBAR ||
            reportOutProps?.type === reportTypeEnum.DUALAXES ||
            reportOutProps?.type === reportTypeEnum.HEATMAP
        ) {
            // const headers = Object.keys(reportOutProps?.data[0]);

            const groupedData = util.groupPartnerData(
                reportOutProps?.data,
                reportOutProps?.year
            );

            const headers = Object.keys(groupedData[0]);

            return headers.map((header, key) => {
                if (!isPdfView)
                    return (
                        <div
                            key={key}
                            style={key === 0 ? styles.table_col_w60 : styles.table_col_w40}
                        >
                            <p style={styles.table_col_header}>{util.toPascalText(header)}</p>
                        </div>
                    );
                else
                    return (
                        <View key={key} style={styles.table_col_w40}>
                            <Text style={styles.table_col_header}>
                                {util.toPascalText(header)}
                            </Text>
                        </View>
                    );
            });
        }
    };

    const renderTableRows = (isPdfView) => {
        const groupedData = util.groupPartnerData(
            reportOutProps?.data,
            reportOutProps?.year
        );

        return groupedData?.map((row, index) => {
            if (!isPdfView)
                return (
                    <div key={index} style={styles.table_row}>
                        {Object.entries(row).map(([key, value]) => {
                            return (
                                <p key={key} style={styles.table_col_w48}>
                                    {value}
                                </p>
                            );
                        })}
                    </div>
                );
            else
                return (
                    <View key={index} style={styles.table_row}>
                        {Object.entries(row).map(([key, value]) => (
                            <Text key={key} style={styles.table_col_w60}>
                                {value}
                            </Text>
                        ))}
                    </View>
                );
        });
    };

    const renderGenericPDFTable = (isPdfView) => {
        if (isPdfView) {
            return (
                <View key="generic_table" style={styles.table}>
                    <View key="generic_title" style={styles.table_title}>
                        <Text>
                            {TableList[0]}: {reportOutProps?.title}
                        </Text>
                    </View>
                    <View key="generic_headers" style={styles.table_layout}>
                        {renderTableHeaders(isPdfView)}
                    </View>
                    {renderTableRows(isPdfView)}
                </View>
            );
        } else
            return (
                <div key="generic_table" style={styles.table}>
                    <div key="generic_title" style={styles.table_title}>
                        <h3>
                            {TableList[0]}: {reportOutProps?.title}
                        </h3>
                    </div>
                    <div key="generic_headers" style={styles.table_layout}>
                        {renderTableHeaders(isPdfView)}
                    </div>
                    {renderTableRows(isPdfView)}
                </div>
            );
    };

    const showPreviewTable = () => (
        <div key="table_details" style={styles.table}>
            <div key="title" style={styles.table_title}>
                <h3>
                    {TableList[0]}: {reportOutProps?.title}
                </h3>
            </div>
            <div key="headers" style={styles.table_layout}>
                <div key="header_measures" style={styles.table_col_w48}>
                    <p style={styles.table_col_header}>Measure</p>
                </div>
                <div key="header_value" style={styles.table_col_w40}>
                    <p style={styles.table_col_header}>Value</p>
                </div>
                <div key="header_perc" style={styles.table_col_w40}>
                    <p style={styles.table_col_header}>Percent (%)</p>
                </div>
            </div>
            {reportOutProps.data?.map((item, rowIndex) => {

                return (
                    rowIndex < 11 && (
                        <div key={rowIndex} style={styles.table_row}>
                            <p key="report_type" style={styles.table_col_w48}>
                                {item.type}
                            </p>
                            <p key="report_value" style={styles.table_col_w40}>
                                {item.value}
                            </p>
                            <p key="report_perc" style={styles.table_col_w40}>
                                {item.percent ? item.percent :
                                    Number(
                                        (item.value /
                                            reportOutProps.data?.reduce(
                                                (acc, currentValue) => acc + currentValue.value,
                                                0
                                            )) *
                                        100
                                    ).toFixed(2)
                                }
                            </p>
                        </div>
                    )
                );
            })}

            {reportOutProps.data.length > 11 && (
                <Alert
                    message="Can only preview 10 items"
                    type="warning"
                    closable
                    onClose={onCloseInfo}
                />
            )}
        </div>
    );

    const showPDFTable = () => {
        return (
            <View key="table_details" style={styles.table}>
                <View key="title" style={styles.table_title}>
                    <Text>
                        {TableList[0]}: {reportOutProps?.title}
                    </Text>
                </View>
                <View key="headers" style={styles.table_layout}>
                    <View key="header_measures" style={styles.table_col_w48}>
                        <Text style={styles.table_col_header}>Measure</Text>
                    </View>
                    <View key="header_value" style={styles.table_col_w40}>
                        <Text style={styles.table_col_header}>Value</Text>
                    </View>
                    <View key="header_perc" style={styles.table_col_w40}>
                        <Text style={styles.table_col_header}>Percent (%)</Text>
                    </View>
                </View>
                {reportOutProps.data?.map((item, rowIndex) => (
                    <View key={rowIndex} style={styles.table_row}>
                        <Text key="report_type" style={styles.table_col_w48}>
                            {item.type}
                        </Text>
                        <Text key="report_value" style={styles.table_col_w40}>
                            {item.value}
                        </Text>
                        <Text key="report_perc" style={styles.table_col_w40}>
                            {item.percent ? item.percent :
                                Number(
                                    (item.value /
                                        reportOutProps.data?.reduce(
                                            (acc, currentValue) => acc + currentValue.value,
                                            0
                                        )) *
                                    100
                                ).toFixed(2)
                            }
                        </Text>
                    </View>
                ))}
            </View>
        );
    };

    const renderPDFTable = (isPDFView) => {
        if (isPDFView) return showPDFTable();
        else return showPreviewTable();
    };

    const renderChart = () => {

        if (!isGeo) {
            return (
                <GenericChart
                    data={reportOutProps?.data?.filter(item => item.value > 0)}
                    type={reportOutProps.type}
                    color={reportOutProps.color}
                    year={reportOutProps.year}
                    description={reportOutProps.desc}
                    title={reportOutProps.desc}
                    xLabel={reportOutProps.xLabel}
                    yLabel={reportOutProps.yLabel}
                    xAxisLabel={reportOutProps.xAxisLabel}
                    yAxisLabel={reportOutProps.yAxisLabel}
                    seriesField={reportOutProps.seriesField}
                    yField={reportOutProps.yField}
                    xField={reportOutProps.xField}
                    onImageSrc={handleImageSrc}
                    isStack={reportOutProps.isStack}
                    stack={reportOutProps.stack}
                />
            );
        } else if (
            isGeo &&
            (reportOutProps.type == reportTypeEnum.GEO_PROVINCES ||
                reportOutProps.type == reportTypeEnum.GEO_MUNICIPALS)
        ) {
            return (
                <GenericGeoMap
                    data={reportOutProps?.data}
                    hoverText={reportOutProps?.description}
                    dataSource={reportOutProps?.dataSource}
                    rptType={reportOutProps.type}
                    width="90%"
                    annotatedCssContainer="census-info-hover__preview"
                    annotatedCssText="census-info__preview"
                    onImageSrc={handleImageSrc}
                    onLegendSrc={handleLegendSrc}
                />
            );
        }
    };

    const renderMetaData = () => (
        <View key="metadata" style={styles.summary}>
            {/* <View key="metadata_source" style={styles.summary__content}>
        <Text>Source: Maths Foundation, Eskom, UNISA</Text>
      </View> */}
            <View key="metadata_desc">
                <Text>Description: {reportOutProps.description}</Text>
            </View>
            <View key="metadata_indicator">
                <Text>Indicator: {reportOutProps?.title}</Text>
            </View>
            <View key="metadata_year">
                <Text>Year measured: {reportOutProps.year}</Text>
            </View>

            {/* Methodology and Competition are not shown at the moment, this will be shown once we have more info them if it's necessary to show */}
            {false && (
                <>
                    <View key="metadata_methodology">
                        <Text>Methodology: This was calculcated using ...</Text>
                    </View>
                    <View key="metadata_competition">
                        <Text>
                            Competition: South African Physics Olympiad (SAPho) (Olympiads)
                        </Text>
                    </View>
                </>
            )}
        </View>
    );

    return (
        <Modal
            open={show}
            onCancel={onModalCancel}
            title={reportOutProps?.title}
            footer={[
                <Button key="cancel" type="danger" onClick={onModalCancel}>
                    Cancel
                </Button>,
                !pdfView && (
                    <Button key="print" type="primary" onClick={onPrint}>
                        Print
                    </Button>
                ),
                !pdfView && (
                    <Button key="downaload" type="primary" onClick={onDownload}>
                        Download Data
                    </Button>
                ),
            ]}
            centered
            width="70%"
        >
            <>
                {!pdfView ? (
                    <div>
                        <h3 style={styles.reportDesc}>
                            {reportOutProps?.title} - {reportOutProps.year}
                        </h3>

                        {
                            //Any other grpahs
                            reportOutProps?.type === reportTypeEnum.GROUPCOL ||
                                reportOutProps?.type === reportTypeEnum.GROUPBAR ||
                                reportOutProps?.type === reportTypeEnum.DUALAXES ||
                                reportOutProps?.type === reportTypeEnum.HEATMAP

                                ?
                                <div key="preview-1" style={styles.preview__report}>
                                    <div >{renderChart()}</div>
                                    <div key="preview-2" style={{ flex: 1 }}>
                                        {renderGenericPDFTable(false)}
                                    </div>
                                </div>
                                :
                                //Geographic graphs
                                <div key="preview-1" style={styles.preview__report}>
                                    <div style={{ width: chartSize }}>{renderChart()}</div>
                                    <div key="preview-2" style={{ flex: 1 }}>
                                        {renderPDFTable(false)}
                                    </div>

                                </div>
                        }

                        <div key="preview-3" style={styles.summary}>
                            {/* <div key="preview-3-text-1">
                Source: Maths Foundation, Eskom, UNISA
              </div> */}
                            <div key="preview-3-text-2">
                                Description: {reportOutProps.description}
                            </div>
                            <div key="preview-3-text-3">
                                Indicator: {reportOutProps?.title}
                            </div>
                            <div key="preview-3-text-4">
                                Year measured: {reportOutProps.year}
                            </div>
                        </div>
                    </div>
                ) : (
                    <PDFViewer width="100%" height="600">
                        <Document pageMode="fullScreen">
                            <Page style={styles.page}>
                                <View key="download-1" style={styles.header}>
                                    <Image key="logo-dst" style={styles.logo} source={DSILogo} />
                                    <Image
                                        key="logo-saasta"
                                        style={styles.logo}
                                        source={SAASTALogo}
                                    />
                                </View>
                                <View key="download-2">
                                    <Text key="download-2-title" style={styles.reportDesc}>
                                        {reportOutProps?.title} - {reportOutProps.year}
                                    </Text>
                                </View>

                                {imageSrc ? (
                                    <View
                                        key="download-2-image"
                                        style={{ width: "100%", marginBottom: "20px" }}
                                    >
                                        <Image key="map" style={styles.images} source={imageSrc} />
                                        {legendSrc && isGeo && (
                                            <Image
                                                key="legend"
                                                style={styles.legend}
                                                source={legendSrc}
                                            />
                                        )}
                                    </View>
                                ) : (
                                    <Text>Failed to load chart</Text>
                                )}
                                {
                                    reportOutProps?.type === reportTypeEnum.GROUPCOL ||
                                        reportOutProps?.type === reportTypeEnum.GROUPBAR ||
                                        reportOutProps?.type === reportTypeEnum.DUALAXES ||
                                        reportOutProps?.type === reportTypeEnum.HEATMAP
                                        ? renderGenericPDFTable(true)
                                        : renderPDFTable(true)

                                }
                                {renderMetaData()}
                                <Text style={styles.footer}>
                                    Report produced by SEIMS Core System on{" "}
                                    {new Date().toLocaleDateString()}
                                </Text>
                            </Page>
                        </Document>
                    </PDFViewer>
                )}
            </>
        </Modal>
    );
};
